export const MOVE_TO_NEXT_STEP = "MOVE_TO_NEXT_STEP";
export const MOVE_TO_PREVIOUS_STEP = "MOVE_TO_PREVIOUS_STEP";
export const SET_IMPORT_ID = "SET_IMPORT_ID";
export const RESET_IMPORT_STEPPER = "RESET_IMPORT_STEPPER";
export const MOVE_TO_SPECIFIC_STEP = "MOVE_TO_SPECIFIC_STEP"
